/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const dataSplitLearnMore = 'https://aka.ms/clu-data-split';
export const multiLingualLearnMore = 'https://aka.ms/clu-multilingual';
export const confusionMatrixCluLearnMore = 'https://aka.ms/clu-confusion-matrix';
export const conversationTrainingLearnMore = 'https://aka.ms/clu-training-concepts';
export const orchestrationTrainingLearnMore = 'https://aka.ms/orchestration-training-concepts';
export const feedback =
    'https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbR99gwTExy1BEgYuDKQY3LyhURDVKM1kyVUZVWTBFSlczMlRCTllJMUY5Ui4u';
